import { Box, Grid, TableCell, TableRow, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import FormField from "../../../../components/common/FormField";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  SUBCONTRACTOR_DETAILS,
  SUBCONTRACTOR_QUOTE_HEADINGS,
} from "./subContractor";
import deleteIcon from "../../../../assets/delete.png";
import editIcon from "../../../../assets/images/actionIcon/edit.png";
import {
  deleteSubContractorAction,
  getSingleSubContractorAction,
  setAddSubContractorResponse,
  setDeleteSubContractorResponse,
  setUpdateSubContractorLeadResponse,
  updateSubContractorLeadAction,
} from "../../../../store/reducers/subContractor";
import ManageSubContractor from "./ManageSubContractor";
import DeleteAlert from "../../../../components/common/DeleteAlert";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import TableDesign from "../../../../components/common/table/TableDesign";
import { shortFormatDay } from "../../../../hooks/helper";
import CustomButton from "../../../../components/common/button/CustomButton";

const SubContractorDetails = ({ selectedId }: any) => {
  const dispatch = useDispatch();
  const {
    subContractorDetails,
    isDeleteResponseSuccess,
    isAddSubContractorSuccess,
    isUpdateSubContractorLeadSuccess,
  } = useSelector((state: any) => state.subContractor);

  const [open, setOpen] = useState(false);
  const [alerModeShow, setAlerModeShow] = useState(false);
  const [editRowId, setEditRowId] = useState<string | null>(null);
  const [rowValues, setRowValues] = useState<any>({});

  useEffect(() => {
    if (selectedId) {
      dispatch(getSingleSubContractorAction({ id: selectedId }));
    }
  }, [selectedId, isAddSubContractorSuccess, isDeleteResponseSuccess]);

  const handleEdit = () => {
    setOpen(true);
  };

 // when click edit
  const handleEditRow = (row: any) => {
    setEditRowId(row.quote_id);

    setRowValues((prev: any) => ({
      ...prev,
      [row.quote_id]: {
        subcontractor_ref: row.subcontractor_ref ?? "",
      },
    }));
  };


// typing
  const handleChange = (id: string, value: string) => {
    setRowValues((prev: any) => ({
      ...prev,
      [id]: {
        subcontractor_ref: value,
      },
    }));
  };


  // save
  const handleSaveRow = (row: any) => {
    const payload = [
      {
        id: selectedId,
        quote_id: row.quote_id,
        subcontractor_ref:
          rowValues[row.quote_id]?.subcontractor_ref ?? "",
      },
    ];

    dispatch(updateSubContractorLeadAction(payload));
  };

  useEffect(() => {
    if (isUpdateSubContractorLeadSuccess) {
      setEditRowId(null);
      dispatch(getSingleSubContractorAction({ id: selectedId }));
      dispatch(setUpdateSubContractorLeadResponse(false));
    }
  }, [isUpdateSubContractorLeadSuccess]);

  const handleDeleteAlert = () => {
    setAlerModeShow(true);
  };

  const handleDelete = () => {
    dispatch(deleteSubContractorAction({ id: selectedId }));
  };

  useEffect(() => {
    if (isDeleteResponseSuccess || isAddSubContractorSuccess) {
      setAlerModeShow(false);
      setOpen(false);
      dispatch(setDeleteSubContractorResponse(false));
      dispatch(setAddSubContractorResponse(false));
    }
  }, [isDeleteResponseSuccess, isAddSubContractorSuccess]);

  return (
    <>
      {alerModeShow && (
        <DeleteAlert
          alertModalShow={alerModeShow}
          onConfirm={() => {
            handleDelete();
          }}
          message={
            "Are you sure you want to delete this sub contractor record?"
          }
          setAlertModelShow={setAlerModeShow}
        />
      )}
      {open && (
        <ManageSubContractor
          open={open}
          onHide={() => setOpen(false)}
          title="Edit Sub Contractor"
          selectedRow={selectedId}
          action="edit"
        />
      )}
      <Grid
        container
        sx={{
          width: "100% !important",
          marginTop: "10px",
          padding: "10px !important",
          border: "1px solid #C4CDD5",
          borderRadius: "5px",
          overflow: "hidden",
          background: "#E5F4F1",
          position: "relative",
        }}
      >
        {!subContractorDetails?.is_deleted && (
          <Box>
            <img
              onClick={handleDeleteAlert}
              src={deleteIcon}
              style={{
                width: "22px",
                height: "22px",
                position: "absolute",
                right: "45px",
                cursor: "pointer",
              }}
              alt="delete"
            />
            <img
              src={editIcon}
              onClick={handleEdit}
              style={{
                width: "20px",
                height: "20px",
                position: "absolute",
                right: "10px",
                cursor: "pointer",
              }}
              alt="edit"
            />
          </Box>
        )}
        {SUBCONTRACTOR_DETAILS.map((field, index) => (
          <FormField
            key={`${field.id}-${index}`}
            onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
              e.preventDefault()
            }
            {...{
              ...field,
              value: subContractorDetails ? subContractorDetails[field.id] : "",
              // Conditional options for county based on country
              disabled: true,

              variant: "outlined", // Adding this variant prop
              isNonMarginTop: true,
              InputProps: {
                sx:
                  field.type === "text" || field.type === "password"
                    ? { height: "36px" }
                    : {
                        padding: "6px 12px",
                        // height: "36px",
                      },
              },
            }}
          />
        ))}
      </Grid>
      <Grid container sx={{ height: "100%" }}>
        <Grid
          item
          md={12}
          xs={12}
          id="userList"
          sx={{
            height: "100%",
            border: "1px solid #CFCFCF",
            borderRadius: "5px",
            padding: "8px",
            overflow: "hidden",
          }}
        >
          <PageTitle
            title="Sub Contractors Leads"
            // button="Add"
            // onClick={handleOpen}
          />

          <TableDesign
            tableHeadings={SUBCONTRACTOR_QUOTE_HEADINGS}
            pagination={null}
            filterOption={{}}
            stickyHeader={true}
            setFilterOption={() => {}}
            tableHeadColor="#E5F4F1"
            extraCSS={{
              height: "calc(100% - 100px)",
            }}
          >
            {subContractorDetails?.list?.length > 0 ? (
              subContractorDetails.list.map((val: any, idx: number) => (
                <TableRow
                  key={val?.quote_id || idx}
                  // onClick={() => setSelectedId(val?.id)}
                  sx={{
                    cursor: "pointer",
                    marginTop: "10px",
                    padding: "4px !important",
                    borderRadius: "20px !important",
                    backgroundColor:
                      selectedId === val?.quote_id ? "#f0f0f0" : "transparent",
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                      outline: "2px solid #f0f0f0",
                      borderRadius: "0px !important",
                      outlineOffset: "-2px !important",
                    },
                  }}
                >
                  <TableCell align="left">{val?.lead_id}</TableCell>
                  <TableCell>{val?.customer_name}</TableCell>
                  <TableCell>{shortFormatDay(val?.quote_created_at)}</TableCell>
                  <TableCell>{val?.sub_con_fee}</TableCell>
                  <TableCell>{val?.quote_accepted_status}</TableCell>
                  <TableCell>{val?.lead_status}</TableCell>
                  <TableCell>
                    <TextField
                      name="subcontractor_ref"
                      variant="standard"
                      fullWidth
                      multiline
                      minRows={1}
                      maxRows={6}
                      value={
                        editRowId === val.quote_id
                          ? rowValues[val.quote_id]?.subcontractor_ref ??
                            ""
                          : val.subcontractor_ref || ""
                      }
                      InputProps={{
                        readOnly: editRowId !== val.quote_id,
                        disableUnderline: editRowId !== val.quote_id,
                      }}
                      onChange={(e) =>
                        handleChange(val.quote_id, e.target.value)
                      }
                    />
                  </TableCell>

                  <TableCell align="center">
                    {editRowId === val?.quote_id ? (
                      <CustomButton
                        onClick={() => handleSaveRow(val)}
                        style={{ cursor: "pointer" }}
                        title="Save"
                      />
                    ) : (
                      <CustomButton
                        onClick={() => handleEditRow(val)}
                        style={{ cursor: "pointer" }}
                        title="Edit"
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={SUBCONTRACTOR_QUOTE_HEADINGS.length}
                  align="center"
                >
                  No data found.
                </TableCell>
              </TableRow>
            )}
          </TableDesign>
        </Grid>
      </Grid>
    </>
  );
};

export default SubContractorDetails;
